import type {
  AvailableDashboardTypeDto,
  AvailableDashboardWidgetDto,
} from '@pages/IntroducingBroker/DashboardPoC/dashboardApi.types'

export function getAvailableWidgets(
  dashboardTypes: AvailableDashboardTypeDto[]
): AvailableDashboardWidgetDto[] {
  const widgetsById = new Map<string, AvailableDashboardWidgetDto>()

  dashboardTypes.forEach((dashboardType) => {
    dashboardType.layouts.forEach((layout) => {
      flattenAvailableWidgets(layout.widgets).forEach((widget) => {
        if (!widgetsById.has(widget.id)) {
          widgetsById.set(widget.id, widget)
        }
      })
    })
  })

  return [...widgetsById.values()]
}

function flattenAvailableWidgets(
  widgets: AvailableDashboardWidgetDto[]
): AvailableDashboardWidgetDto[] {
  return widgets.flatMap((widget) => {
    if (widget.hasSubWidgets && widget.subWidgets.length > 0) {
      return flattenAvailableWidgets(widget.subWidgets)
    }

    return [widget]
  })
}
